import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';

import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import timeUtils from '../../utils/timeUtils';
import VisitListItem from './VisitListItem';

import { AppText } from '../AppText';

const styles = StyleSheet.create({
  view: {
    backgroundColor: Colors.lightBackground,
  },
  header: {
    height: 56,
    flexDirection: 'row',
  },
  gray: {
    backgroundColor: Colors.lightGray,
  },
  green: {
    backgroundColor: Colors.accentColor,
  },
  white: {
    backgroundColor: Colors.white,
  },
  lightBackground: {
    backgroundColor: Colors.lightBackground,
  },
  borderBottom: {
    borderBottomColor: Colors.grayBorder,
    borderBottomWidth: 1,
  },
  lineContainer: {
    width: 32,
    height: 56,
    position: 'relative',
  },
  line: {
    position: 'absolute',
    left: 16,
    top: 0,
    bottom: 0,
    height: 56,
    width: 1,
  },
  dot: {
    position: 'absolute',
    left: 13,
    top: 25,
    height: 7,
    width: 7,
    backgroundColor: Colors.primaryColor,
    borderRadius: 3.5,
  },
  visits: {
    flex: 1,
  },
  dateText: {
    lineHeight: 56,
  },
  dateContainer: {
    backgroundColor: Colors.lightBackground,
  },
});

class VisitListDay extends PureComponent {
  static propTypes = {
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    serviceDate: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    visits: PropTypes.array.isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any),
    registration: PropTypes.objectOf(PropTypes.any),
  };

  constructor(props) {
    super();
  }

  render() {
    const { serviceDate, translation, locale, visits, actions, navigation, registration } = this.props;
    const todayString = translation.app_today;
    const timestamp = Math.floor(new Date() / 1000);
    const todayDate = timeUtils.getServiceDateFromUnixTimestamp(timestamp);
    const displayDate = timeUtils.getNiceDate(serviceDate, locale, todayString);
    const beforeToday = todayDate > serviceDate;
    const visitList = [];
    visits.forEach((visit, index) => {
      const selectVisit = () => {
        const organizationId = visit.organization_id;
        if (Layout.usePantryTabs) {
          navigation.navigate('Pantry', { id: organizationId });
        } else {
          navigation.navigate('a', {
            screen: 'pantries',
            params: { id: organizationId },
          });
          actions.showSinglePantry(organizationId);
        }
      };
      visitList.push(
        <VisitListItem
          key={`VisitListItem-${index}`}
          visit={visit}
          onSelect={selectVisit}
          beforeToday={beforeToday}
          translation={translation}
          registration={registration}
        />
      );
    });
    const color = beforeToday ? styles.gray : styles.green;
    const backgroundColor = beforeToday ? styles.white : styles.white;
    const headerBottom = beforeToday ? styles.borderBottom : null;

    return (
      <View style={styles.view}>
        <View style={[styles.header, headerBottom]}>
          <View style={styles.lineContainer}>
            <View style={[styles.line, color]}></View>
            <View style={[styles.dot, color]}></View>
          </View>
          <View style={styles.dateContainer}>
            <AppText style={styles.dateText}>{displayDate}</AppText>
          </View>
        </View>
        <View style={[styles.visits, backgroundColor]}>{visitList}</View>
      </View>
    );
  }
}

export default VisitListDay;
